import React from 'react';
import { Box } from '../Box';
import { useStyles } from './Skeleton.styles';
import { SkeletonProps } from './Skeleton.types';

/**
 *       .-.
 *      (o.o)
 *       |=|
 *      __|__
 *    //.=|=.\\
 *   // .=|=. \\
 *   \\ .=|=. //
 *    \\(_=_)//
 *     (:| |:)
 *      || ||
 *      () ()
 *      || ||
 *      || ||
 *     ==' '==
 *
 * @param style
 * @param height
 * @param width
 * @param variant
 * @param className
 * @constructor
 */
export const Skeleton = ({
  style,
  height,
  width,
  variant,
  className,
}: SkeletonProps): JSX.Element => {
  const classes = useStyles({ style, height, width, variant });

  return (
    <Box className={`${classes.root} ${className}`}>
      <Box className={`${classes.skeleton} ${className}`} />
    </Box>
  );
};

Skeleton.defaultProps = {
  style: {},
  height: null,
  width: null,
  variant: 'square',
  className: '',
};
